<template>
  <section
    id="meeting-notes-panel"
    class="panel panel-default"
    role="region"
    aria-labelledby="meeting-notes-heading"
    :aria-busy="!meetingNotesReady"
  >
    <div class="panel-body">
      <div class="panel-header">
        <h2 id="meeting-notes-heading">Meeting Notes</h2>
      </div>
      <p class="sr-only" role="status" aria-live="polite">{{ statusMessage }}</p>
      <p v-if="meetingNotesLoadError" class="sr-only" role="alert">{{ statusMessage }}</p>
      <div v-if="meetingNotesReady" class="meeting-notes-container">
        <meeting-notes-list-section
          title="Actions Required"
          :notes="actionsRequired"
          variant="actions-required"
          :compact-limit="5"
        ></meeting-notes-list-section>

        <meeting-notes-list-section
          title="Mentor Sessions"
          :notes="mentorSessions"
          variant="mentor-sessions"
          :compact-limit="5"
        ></meeting-notes-list-section>

        <meeting-notes-list-section
          title="Other Notes"
          :notes="otherNotes"
          variant="other-notes"
          :compact-limit="5"
          :collapsible="true"
        ></meeting-notes-list-section>
      </div>
    </div>
  </section>
</template>

<script>
import TimeMixin from '@mixins/time-mixins';
import MeetingNotesListSection from './meeting-notes-list-section.vue';

export default {
  components: {
    MeetingNotesListSection,
  },
  mixins: [TimeMixin],
  props: {
    programmeId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      meetingNotes: [],
      meetingNotesReady: false,
      meetingNotesLoadError: false,
    };
  },

  beforeMount() {
    this.getMeetingNotes();
  },

  watch: {
    programmeId() {
      this.getMeetingNotes();
    },
  },

  computed: {
    actionsRequired() {
      return this.meetingNotes
        .filter(note => note.status === 'In Review')
        .sort(this.sortByMeetingStart);
    },
    mentorSessions() {
      return this.meetingNotes
        .filter(note => note.support_function === 'data_mentor' && note.status === 'Completed')
        .sort(this.sortByMeetingStart);
    },
    otherNotes() {
      return this.meetingNotes
        .filter(note => note.support_function !== 'data_mentor' && note.status === 'Completed')
        .sort(this.sortByMeetingStart);
    },
    statusMessage() {
      if (!this.meetingNotesReady) {
        return 'Loading meeting notes.';
      }
      if (this.meetingNotesLoadError) {
        return 'Unable to load meeting notes right now.';
      }
      return `${this.meetingNotes.length} meeting notes loaded.`;
    },
  },

  methods: {
    getMeetingNotes() {
      this.meetingNotesReady = false;
      this.meetingNotesLoadError = false;
      this.$logger.info('Getting meeting notes');
      this.$http.get(`/api/curriculum/meetings/programme/${this.programmeId}`).then(res => {
        this.meetingNotes = res.data;
      }).catch(err => {
        this.meetingNotesLoadError = true;
        this.$logger.autowarn('Could not get meeting notes', undefined, err);
        this.$ktoast.showError(err);
      }).then(() => {
        this.meetingNotesReady = true;
      });
    },

    sortByMeetingStart(a, b) {
      return this.getDate(b.meeting_start) - this.getDate(a.meeting_start);
    },
  },
};
</script>
